export default {
  workstation: (state) => {
    return state.workstation;
  }
}
